import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

export const Tr4inerOutlinedButton = styled(Button)(() => ({
  color: '#fff',
  fontWeight: 'bold',
  borderColor: '#adb5bd',
  '&:hover': {
    borderColor: '#adb5bd',
    backgroundColor: '#adb5bd',
    color: '#000',
  },
}));

export const Tr4inerContainedButton = styled(Button)(() => ({
  color: 'black',
  fontWeight: 'bold',
  backgroundColor: '#FDB600',
  borderColor: '#FDB600',
  boxShadow: '0px 0px 0px 0px',
  '&:hover': {
    borderColor: '#FDB600',
    backgroundColor: '#FDB600',
    opacity: '0.8',
  },
}));

export const ContainerButtonPlay = styled('div')(() => ({
  position: 'absolute',
  // top: '10px',
  zIndex: '2',
  // right: '17px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  
  width: '100%',
  height: '100%',
}));

export const ButtonPlayStyled = styled(Button)(() => ({
  backgroundColor: 'orange',
  color: 'white',
  borderRadius: '50%',
  '&:hover': {
    backgroundColor: '#bf8f00',
  },
}));
